import {
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
} from '@angular/core';

export interface TabConfig {
  header: string;
  contentTemplate?: TemplateRef<any>;
}

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
})
export class TabComponent {
  @Input() tabs: TabConfig[] = [];
  @Input() activeIndex: number = 0;
  @Input() styleClass: string = 'tabview-custom';
  @Input() scrollable: boolean = false;
  @Input() alignment: 'left' | 'center' = 'center';
  @Output() activeIndexChange = new EventEmitter<number>();
  @Output() onChange = new EventEmitter<any>();

  onTabChange(event: any): void {
    this.activeIndex = event.index;
    this.activeIndexChange.emit(event.index);
    this.onChange.emit(event);
  }

  getTabContent(index: number): TemplateRef<any> | null {
    return this.tabs[index]?.contentTemplate || null;
  }
}
